module.exports = __webpack_public_path__ + "static/media/logo-2.41855a60.png";